import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/jo-doucet")({
  head: () => buildRouteHead("/jo-doucet", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/team", replace: true });
  },
});
